import { I18n } from 'aws-amplify';
import React, { useEffect, useState } from 'react';
import { Tooltip, Box, Button, withStyles } from '@material-ui/core';

import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import FormInputWithOnChange from '@/component/common/form/input-with-onchange';

export default function HtmlFieldUI(props) {
    const defaultValue = props?.defaultValue || '';
    const [htmlEditValue, setHtmlEditValue] = useState(defaultValue);
    const [isPreviewMode, setIsPreviewMode] = useState(true);
    const [isShowFlagMessage, setIsShowFlagMessage] = useState(false);

    const FlagMessageCopyLink = withStyles({
        tooltip: {
            color: '#1DA578',
            backgroundColor: '#D7F4E2',
            padding: '8px 16px',
            fontSize: '14px',
            boxShadow: '6px 5px 5px -4px rgba(0,0,0,0.3)'
        },
        arrow: {
            color: '#D7F4E2'
        }
    })(Tooltip);

    const publicForCustomer = props.data.structure.publicForCustomer;
    const isAddNewTicket = !props?.detailTicket;
    const isViewOnly =
        publicForCustomer == Constant.SETTING_FORM_DEFAULT.READ_ONLY ||
        props.viewFromProjectOfEscalateTicket ||
        !Utils.isEmptyString(props.detailTicket?.deletedAt) ||
        props.hasEditFieldPermissions === false

    const handleChangeHtml = e => {
        if (isViewOnly) return;
        if (props?.setIsEdited) {
            props?.setIsEdited(true);
            props?.setShowButtonEditTicket && props?.setShowButtonEditTicket();
            if (!props?.listFieldEdited?.includes(props?.name)) {
                props?.setListFieldEdited([...props.listFieldEdited, props?.name]);
            }
            if (props?.setOnChangeEdit) {
                props?.setOnChangeEdit(!props.onChangeEdit);
            }
        }
        setHtmlEditValue(e.target.value);
    };

    const handleResetEditedData = () => {
        if (isViewOnly) return;
        props?.clearErrors(props?.name);
        let oldValue = defaultValue;
        props?.setValue(props?.name, oldValue);
        setHtmlEditValue(oldValue);
        setIsPreviewMode(true);
    };

    const getHtmlS3Link = () => {
        const ticketDetail = props?.detailTicket;

        if (!ticketDetail || Utils.isEmptyObject(ticketDetail) || !ticketDetail?.id) return;

        let currentFieldId = props.name;
        if (!currentFieldId) return;

        let ticketId = ticketDetail.id
        if (ticketDetail.ticketType === Constant.TICKET_TYPE.BROADCAST_CHILD) {
            ticketId = ticketDetail.parent;
        }

        return Utils.buildHtmlShareLinkPage(ticketId, currentFieldId)
    }

    const handleCopyLinkS3 = () => {
        let s3Link = getHtmlS3Link();
        if (!s3Link) return;

        navigator.clipboard
            .writeText(s3Link)
            .then(() => {
                setIsShowFlagMessage(true);
                setTimeout(() => {
                    setIsShowFlagMessage(false);
                }, 1500);
            })
            .catch(err => {console.log(`handleCopyLinkS3 err`, err)});
    }

    const handleOpenNewTab = () => {
        let s3Link = getHtmlS3Link();
        if (!s3Link) return;
        window.open(s3Link, '_blank').focus();
    };

    // uef run when init / change tab ticket
    useEffect(() => {
        setIsPreviewMode(!isAddNewTicket);
    }, [props?.detailTicket]);

    // uef run when init / change selectedForm
    useEffect(() => {
        let isKnowledgeForm = [Constant.FORM_TYPE.FORM_KNOWLEDGE, Constant.FORM_TYPE.FORM_MASTER].includes(props?.parentForm?.type);
        if (isAddNewTicket || props?.isDraftMode || (props?.editTicket && !isKnowledgeForm)) {
            props.register(props?.name, {
                onChange: e => {}
            });
        
            props.setValue(props?.name, defaultValue || '');
            setHtmlEditValue(defaultValue || '');
        }
    }, [props?.parentForm]);

    return (
        <div className="form-addTicket field-">
            <div className="cell-prod-status gap-8">
                {props?.isTooltipTitle ? (
                    <div className="d-flex">
                        <Tooltip title={props?.label}>
                            <span className="form-addTicket-label text-truncate">
                                <label
                                    className={
                                        `text-truncate line-height-18 w-f100 ${
                                            (publicForCustomer
                                                ? 'form-addTicket-label-color'
                                                : 'form-addTicket-label')
                                        }`
                                    }
                                >
                                    {props?.label}
                                </label>
                            </span>
                        </Tooltip>
                        {props.data.structure.required && (
                            <span className="required padding-left-4">*</span>
                        )}
                    </div>
                ) : (
                    <label
                        className={
                            `w-f100 ${
                            publicForCustomer
                                ? 'form-addTicket-label-color'
                                : 'form-addTicket-label'
                            }`
                        }
                    >
                        {props?.label}{' '}
                        {props.data.structure.required && <span className="required">*</span>}
                    </label>
                )}

                {props?.isShowIconCopyFieldId && (
                    <Tooltip title={props?.data.id} placement="top" arrow>
                        <img
                            src="/assets/image/icon-copy.svg"
                            alt="copy"
                            onClick={() => navigator.clipboard.writeText(props?.data.id)}
                        />
                    </Tooltip>
                )}
            </div>

            <div className="form-addTicket-input">
                {/* Preview Mode */}
                <Box style={{ display: isPreviewMode ? 'block' : 'none' }}>
                    <Box style={{ display: 'flex'}}>
                        {/* View HTML render */}
                        {isPreviewMode && (
                            <iframe
                                title="html-content"
                                style={{
                                    flex: 1,
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    overflowY: 'auto',
                                    height: '660px'
                                }}
                                srcDoc={htmlEditValue}
                            />
                        )}

                        {/* HTML options */}
                        <div
                            style={{
                                display: 'inline-flex',
                                flexWrap: 'wrap',
                                alignItems: 'flex-start',
                                paddingLeft: '10px',
                                maxWidth: '88px',
                                alignContent: 'start'
                        }}>
                            {!isAddNewTicket && (
                                <>
                                    <Button className="button-html html-link cursor-default" onClick={handleCopyLinkS3}>
                                        <FlagMessageCopyLink
                                            title={I18n.get('KNOWDEMSG002')}
                                            placement="top-start"
                                            arrow={true}
                                            open={isShowFlagMessage}
                                        >
                                            <img src="/assets/image/html-link-icon.svg" alt="" className="cursor-pointer" />
                                        </FlagMessageCopyLink>
                                    </Button>
                                    <Button className="button-html html-blank cursor-default" onClick={handleOpenNewTab}>
                                        <img src="/assets/image/html-open-new-tab-icon.svg" alt="" className="cursor-pointer" />
                                    </Button>
                                </>
                            )}
                            {!isViewOnly && (
                                <Button
                                    className="button-html cursor-default"
                                    disabled={isViewOnly}
                                    onClick={() => {
                                        if (isViewOnly) return;
                                        setIsPreviewMode(prev => !prev);
                                    }
                                }>
                                    <img src="/assets/image/button-url-edit.svg" alt="" className="cursor-pointer" />
                                </Button>
                            )}
                        </div>
                    </Box>

                </Box>

                {/* Edit Mode */}
                <Box style={{ display: !isPreviewMode ? 'block' : 'none' }}>
                    <Box display="flex" sx={{ width: '100%' }}>
                        <Box sx={{ flexGrow: 1, paddingRight: '10px' }}>
                            <FormInputWithOnChange
                                name={props?.name}
                                className="form-control form-control-wrapTextarea form-control-hg400"
                                variant="outlined"
                                defaultValue={htmlEditValue}
                                value={htmlEditValue}
                                multiline
                                rows={4}
                                disabled={isViewOnly}
                                errorlist={props?.errorlist}
                                autoComplete="off"
                                required={props?.required}
                                onChange={handleChangeHtml}
                                data-cy="text-area-input-field"
                                isDisableOnBlur={props.isDisableOnBlur ? props.isDisableOnBlur : true}
                            />

                        </Box>
                        <Box display="inline-flex" alignItems="flex-start">
                            <Button
                                className="button-mermaid cursor-default"
                                onClick={() => {
                                    if (isViewOnly) return;
                                    if (props?.errorlist.hasOwnProperty(props?.name)) return;
                                    setIsPreviewMode(prev => !prev)
                                }}
                            >
                                <img src="/assets/image/button-url-apply.svg" alt="" className="cursor-pointer" />
                            </Button>
                            <Button
                                className="button-mermaid cursor-default"
                                onClick={handleResetEditedData}
                                style={{ paddingRight: '0px' }}
                            >
                                <img src="/assets/image/button-url-reset.svg" alt="" className="cursor-pointer" />
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </div>
        </div>
    );
};
